import React, { FC, useContext, useEffect, useState } from "react";
import { PersonalInformationContainer } from "../../../../hirings/new-hiring/health/forms/personal-information/personal-information-style";
import CalendarBox from "../../../../../components/calendar-box/calendar-box";
import { UseFormFunctionsProps } from "../../hooks/hooks.types";
import { deepGet } from "../../../../../utils/utility";
import moment from "moment";
import SelectBox from "../../../../../components/select-box/select-box";
import { DynamicProductsContext } from "../../../../../context/constants";
import { loadPayTypes, getProductIdFromCollective } from "../../new-insured/required-documents/utils";
import { getCollective } from "../../utils";
import { ProductPayType } from "../../../../../services/PayTypesServices.dto";
import { filterStringProperties } from "./utils";
import InputBox from "../../../../../components/input-box/input-box";
import { getPaymentTime } from "../../../comparator/health-comparator/assets";

const PolicyData: FC<UseFormFunctionsProps> = ({
  values,
  errors,
  handleChange,
}) => {
  const context = useContext(DynamicProductsContext);
  const allProducts = deepGet(context, 'allProducts', null);
  const [payType, setPayType] = useState<ProductPayType[]>([]);

  useEffect(() => {
    if (allProducts && Object.keys(allProducts).length > 0) {
        loadPayTypes(getProductIdFromCollective(allProducts, getCollective()), setPayType);
    }
}, [allProducts]);

  return (
    <PersonalInformationContainer>
      <div className="content-wrapper">
        <div className="personal-data-wrapper">
          <div className="data-title" id="data-personal">
            <h5>DATOS DE PÓLIZA</h5>
          </div>
          <div className="personal-data-fisica">
            <div className="personal-data-row">
              <div className="personal-data-item col-50">
                <div className="inputBox">
                  <CalendarBox
                    initialValue={values.policy.startDate}
                    placeholder="Fecha de INICIO"
                    minDate={moment().subtract(1, "days").toISOString()}
                    required
                    disabled={false}
                    errorCode={deepGet(errors, "policy.startDate", "")}
                    onChange={(value: string) => handleChange("startDate", value, "policy")}
                  />
                </div>
              </div>
              <div className="personal-data-item col-50">
                <div className="selectBox">
                  <SelectBox
                    labelText=""
                    required
                    errorCode={deepGet(errors, "policy.payTypeValue", "")}
                    optionsText={filterStringProperties(payType)}
                    optionKey={"value"}
                    optionValue={"label"}
                    initialValue={values.policy.payType}
                    onChange={(value: string) => {
                      handleChange("payType", value, "policy");
                      handleChange("payTypeValue", getPaymentTime(value), "policy");

                    }}
                  />
                  <label>Tipo de pago</label>
                </div>
              </div>
            </div>
          </div>
          <div className="personal-data-fisica">
            <div className="personal-data-item col-50">
                <div className="inputBox">
                    <InputBox
                      type={"iban"}
                      placeholder="iban"
                      required
                      errorCode={deepGet(errors, "policy.iban", "")}
                      value={values.policy.iban}
                      onChange={(value: string) => handleChange("iban", value, "policy")}
                    />
                </div>
            </div>
          </div>
        </div>
      </div>
    </PersonalInformationContainer>
  );
};

export default PolicyData;
